import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompaniesService } from '../services/companies.service';

@Injectable()
export class CompanyHeaderInterceptor implements HttpInterceptor {

  constructor(private companiesService: CompaniesService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtener la compañía seleccionada directamente del localStorage para evitar problemas de sincronización
    const storedCompanyRaw = localStorage.getItem('selectedCompany');
    let companyId = 1; // Default

    if (storedCompanyRaw) {
      try {
        const company = JSON.parse(storedCompanyRaw);
        companyId = company?.IdCompany || 1;
      } catch (e) {
        console.error('Error parsing selectedCompany from localStorage:', e);
      }
    }
    
    // Clonar la request y agregar el header (se combina con otros headers existentes)
    const clonedRequest = request.clone({
      setHeaders: {
        'x-company-id': companyId.toString()
      }
    });
    
    return next.handle(clonedRequest);
  }
}
